import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericFilter } from '../models/GenericFilter';
import { ProjectGroupRoleDto, ProjectGroupRoleForCreationDto } from '../models/projectgrouprole';
import { BaseService } from './base.service';

@Injectable({ providedIn: 'root'})
export class ProjectGroupRoleService  extends BaseService {  
  
  constructor(private httpClient: HttpClient) {
    super();
   }

   getProjectGroupRole(id:string): Observable<ProjectGroupRoleDto[]> {
    return this.httpClient.get<ProjectGroupRoleDto[]>(`${this.projectGroupRoles}/${id}`);
  }

   getProjectGroupRoles(searchText:string, projectId:string, page?:number, pageSize?:number) :Observable<ProjectGroupRoleDto[]> {
    return this.httpClient.get<ProjectGroupRoleDto[]>(`${this.projectGroupRoles}?searchText=${searchText}&projectId=${projectId}&page=${page}&pageSize=${pageSize}`);
  } 
  
  // loadProjectGroupRoles(projectId:string, genericFilter: GenericFilter): Observable<ProjectGroupRoleDto[]> {
  //   return this.httpClient.post<ProjectGroupRoleDto[]>(`${this.projectGroupRoles}/${projectId}/GetFilteredProjectGroupRoles`, genericFilter);
  // }

  // createProjectGroupRole(projectGroupRole: ProjectGroupRoleForCreationDto): Observable<ProjectGroupRoleForCreationDto> {
  //   return this.httpClient.post<ProjectGroupRoleForCreationDto>(`${this.projectGroupRoles}`, projectGroupRole);
  // }

  // deleteProjectGroupRole(id: string): Observable<any> {
  //   return this.httpClient.delete<any>(`${this.projectGroupRoles}/${id}/DeleteProjectGroupRole`);
  // }
}
